import {Div} from '@quarks';
import styled from 'styled-components';
import {WorkspaceIcon} from './HaNWorkspaceIcon';

export const StyledContainer = styled(Div)<{
  $iconType: WorkspaceIcon;
  secondary?: boolean;
  activeVariant?: 'A' | 'B';
}>`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({$iconType}) => ($iconType === 'desk' || $iconType === 'area' ? '8px' : '12px')};
  border: ${({$iconType, theme}) =>
    $iconType === 'unknown' ? `1px solid ${theme.border.color.sensorStatusUnknwon}` : null};

  background: ${({$iconType, theme, secondary, activeVariant}) => {
    const colorGroup = secondary
      ? activeVariant === 'B'
        ? theme.occupancyUpdatedB
        : theme.occupancyUpdated
      : theme.occupancy;

    switch ($iconType) {
      case 'full':
        return colorGroup.red;
      case 'busy':
        return colorGroup.orange;
      case 'lively':
        return colorGroup.yellow;
      case 'quiet':
        return colorGroup.green;
      case 'desk':
      case 'area':
        return theme.card.beige500.background;
      case 'unknown':
        return colorGroup.sensorAway || theme.occupancy.sensorAway;
      default:
        return 'none';
    }
  }};
`;
